module.exports = __webpack_public_path__ + "static/media/soundBanner.5e3a5a5b.png";